import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../Assets/writeme.png";
import Spinner from "../../Components/Spinner/Spinner";
import axios from "axios";
import { toast } from "react-toastify";
import { parseJwt } from "../../utils/parseJwt";
import baseUrl from "../../baseUrl";

const EmailVerification = () => {
  const userToken = JSON.parse(localStorage.getItem("user-token"));
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (userToken) {
      const userId = parseJwt(userToken);
      setUserId(userId.id);
    }
  }, [userId, userToken]);

  const handleVerification = (e) => {
    e.preventDefault();
    if (otp) {
      setLoading(true);
      axios
        .post(`${baseUrl}/user/verify-email`, {
          otp: otp,
          userId: userId,
        })
        .then((res) => {
          if (res.data.success === true) {
            localStorage.removeItem("user-token");
            toast.success(res.data.message);
            navigate("/signin");
          } else {
            toast.error(res.data.message);
            navigate("/verify-email");
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast.error("Please fill all the fields");
    }
  };
  return (
    <>
      {loading && <Spinner />}
      {userToken ? (
        <div className="min-h-screen bg-white flex justify-center items-center">
          <form
            onSubmit={handleVerification}
            className="py-12 px-12 bg-gray-200 rounded-2xl shadow-xl z-20"
          >
            <div className="flex flex-col">
              <Link to="/">
                <img
                  src={Logo}
                  className="align-middle mx-auto"
                  width="70px"
                  height="70px"
                  alt="logo"
                  draggable="false"
                />
              </Link>
              <h1 className="text-3xl capitalize font-bold text-center mb-4 ">
                Verifiy Your Email
              </h1>
            </div>
            <div className="space-y-4">
              <input
                type="number"
                name="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Enter 4 digits OTP"
                className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
                required
              />
            </div>
            <div className="text-center mt-6">
              <button className="py-3 w-64 text-xl text-white bg-indigo-500 rounded-2xl">
                {loading ? "Verifying..." : "Verify Email"}
              </button>

              <p className="mt-4 text-sm">
                Already Verified your email?
                <span className="underline cursor-pointer ml-2">
                  <Link to="/signin">Sign In</Link>
                </span>
              </p>
            </div>
          </form>
        </div>
      ) : (
        <div className="min-h-screen bg-white flex justify-center items-center">
          <form className="py-12 px-12 bg-gray-200 rounded-2xl shadow-xl z-20">
            <div className="flex flex-col">
              <Link to="/">
                <img
                  src={Logo}
                  className="align-middle mx-auto"
                  width="70px"
                  height="70px"
                  alt="logo"
                  draggable="false"
                />
              </Link>
              <h1 className="text-3xl capitalize font-bold text-center mb-4 ">
                Cannot Verifiy Your Email
              </h1>
            </div>
            <div className="space-y-4">
              <input
                type="number"
                name="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="Cannot enter 4 digits OTP"
                className="block text-sm py-3 px-4 rounded-lg w-full border outline-none"
                required
                disabled
              />
            </div>
            <div className="text-center mt-6">
              <button
                disabled
                className="py-3 w-64 text-xl text-white bg-gray-500 rounded-2xl"
              >
                No Accessible
              </button>

              <p className="mt-4 text-sm">
                Already Verified your email?
                <span className="underline cursor-pointer ml-2">
                  <Link to="/signin">Sign In</Link>
                </span>
              </p>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default EmailVerification;
